
export const taludMap = [
  'steil',
  'normaal',
  'vlak'
]

export const debietMap = [
  'laag',
  'normaal',
  'hoog'
]

export const scenarioDefault = {
  voorland: 0,
  ruwheid : 0,
  talud   : 1,
  debiet  : 1
}

export const faalkansText = {
  standaard: 'Uitgangspunt zijn de zogenaamde <strong>startwaarden</strong> voor de faalkansbegroting voor een dijk, met achtereenvolgens 24% voor ‘Overloop en Golfoverslag’, 24% voor ‘Opbarsten en piping’ en 4% voor ‘Macrostabiliteit binnenwaarts.’',
  'variant-a': 'In deze variant is een groot deel van de faalkansruimte toegekend aan <strong>piping</strong> (44%), met daarbij 4% voor ‘Overloop en Golfoverslag’ en 4% voor ‘Macrostabiliteit binnenwaarts.’',
  'variant-b': 'In deze variant is een groot deel van de faalkansruimte toegekend aan <strong>macrostabiliteit</strong> binnenwaarts (44%), met daarbij 4% voor ‘Overloop en Golfoverslag’ en 4% voor ‘Opbarsten en piping.'
}

export const defaultKruin = 7.641

export const scenarioData = [
  // Talud steil
  // 1
  {
    voorland: 1,
    ruwheid : 1,
    talud   : 2,
    debiet  : 0,
    stage   : {
      city    : 1,
      easter  : 0,
      house   : 1,
      factor  : 0.9296,
      kruin   : 7.103,
      popups  : ['1', '2a', '3a', '4a'],
      talud   : 2,
      voorland: 1,
      ruwheidDijk : 0,
      ruwheidVoorland : 1,
    }
  },
  {
    voorland: 1,
    ruwheid : 1,
    talud   : 2,
    debiet  : 1,
    stage   : {
      city    : 1,
      easter  : 0,
      house   : 0,
      factor  : 0.8635,
      kruin   : 6.598,
      popups  : ['1', '2a', '3a'],
      talud   : 2,
      voorland: 1,
      ruwheidDijk : 0,
      ruwheidVoorland : 1,
    }
  },
  {
    voorland: 1,
    ruwheid : 1,
    talud   : 2,
    debiet  : 2,
    stage   : {
      city    : 0,
      easter  : 0,
      house   : 0,
      factor  : 0.8367,
      kruin   : 6.393,
      popups  : ['1', '2a', '3a', '4b'],
      talud   : 2,
      voorland: 1,
      ruwheidDijk : 0,
      ruwheidVoorland : 1,
    }
  },

  // 2
  {
    voorland: 0,
    ruwheid : 1,
    talud   : 2,
    debiet  : 0,
    stage   : {
      city    : 1,
      easter  : 0,
      house   : 1,
      factor  : 1.0005,
      kruin   : 7.645,
      popups  : ['2b', '3a', '4a'],
      talud   : 2,
      voorland: 0,
      ruwheidDijk : 1,
      ruwheidVoorland : 0,
    }
  },
  {
    voorland: 0,
    ruwheid : 1,
    talud   : 2,
    debiet  : 1,
    stage   : {
      city    : 1,
      easter  : 0,
      house   : 0,
      factor  : 0.9316,
      kruin   : 7.118,
      popups  : ['2b', '3a'],
      talud   : 2,
      voorland: 0,
      ruwheidDijk : 1,
      ruwheidVoorland : 0,
    }
  },
  {
    voorland: 0,
    ruwheid : 1,
    talud   : 2,
    debiet  : 2,
    stage   : {
      city    : 0,
      easter  : 0,
      house   : 0,
      factor  : 0.8961,
      kruin   : 6.847,
      popups  : ['2b', '3a', '4b'],
      talud   : 2,
      voorland: 0,
      ruwheidDijk : 1,
      ruwheidVoorland : 0,
    }
  },

  // 3
  {
    voorland: 1,
    ruwheid : 0,
    talud   : 2,
    debiet  : 0,
    stage   : {
      city    : 1,
      easter  : 0,
      house   : 1,
      factor  : 1.0242,
      kruin   : 7.826,
      popups  : ['1', '3a', '4a'],
      talud   : 2,
      voorland: 1,
      ruwheidDijk : 0,
      ruwheidVoorland : 0,
    }
  },
  {
    voorland: 1,
    ruwheid : 0,
    talud   : 2,
    debiet  : 1,
    stage   : {
      city    : 1,
      easter  : 0,
      house   : 0,
      factor  : 0.9352,
      kruin   : 7.146,
      popups  : ['1', '3a'],
      talud   : 2,
      voorland: 1,
      ruwheidDijk : 0,
      ruwheidVoorland : 0,
    }
  },
  {
    voorland: 1,
    ruwheid : 0,
    talud   : 2,
    debiet  : 2,
    stage   : {
      city    : 0,
      easter  : 0,
      house   : 0,
      factor  : 0.8974,
      kruin   : 6.857,
      popups  : ['1', '3a', '4b'],
      talud   : 2,
      voorland: 1,
      ruwheidDijk : 0,
      ruwheidVoorland : 0,
    }
  },

  // 4
  {
    voorland: 0,
    ruwheid : 0,
    talud   : 2,
    debiet  : 0,
    stage   : {
      city    : 1,
      easter  : 1,
      house   : 1,
      factor  : 1.1128,
      kruin   : 8.503,
      popups  : ['3a', '4a'],
      talud   : 2,
      voorland: 0,
      ruwheidDijk : 0,
      ruwheidVoorland : 0,
    }
  },
  {
    voorland: 0,
    ruwheid : 0,
    talud   : 2,
    debiet  : 1,
    stage   : {
      city    : 1,
      easter  : 0,
      house   : 0,
      factor  : 1.0145,
      kruin   : 7.752,
      popups  : ['3a'],
      talud   : 2,
      voorland: 0,
      ruwheidDijk : 0,
      ruwheidVoorland : 0,
    }
  },
  {
    voorland: 0,
    ruwheid : 0,
    talud   : 2,
    debiet  : 2,
    stage   : {
      city    : 0,
      easter  : 0,
      house   : 0,
      factor  : 0.9733,
      kruin   : 7.437,
      popups  : ['3a', '4b'],
      talud   : 2,
      voorland: 0,
      ruwheidDijk : 0,
      ruwheidVoorland : 0,
    }
  },

  // Talud normaal
  // 1
  {
    voorland: 1,
    ruwheid : 1,
    talud   : 1,
    debiet  : 0,
    stage   : {
      city    : 1,
      easter  : 0,
      house   : 1,
      factor  : 0.9198,
      kruin   : 7.028,
      popups  : ['1', '2a', '4a'],
      talud   : 1,
      voorland: 1,
      ruwheidDijk : 0,
      ruwheidVoorland : 1,
    }
  },
  {
    voorland: 1,
    ruwheid : 1,
    talud   : 1,
    debiet  : 1,
    stage   : {
      city    : 1,
      easter  : 0,
      house   : 0,
      factor  : 0.8589,
      kruin   : 6.563,
      popups  : ['1', '2a'],
      talud   : 1,
      voorland: 1,
      ruwheidDijk : 0,
      ruwheidVoorland : 1,
    }
  },
  {
    voorland: 1,
    ruwheid : 1,
    talud   : 1,
    debiet  : 2,
    stage   : {
      city    : 0,
      easter  : 0,
      house   : 0,
      factor  : 0.8338,
      kruin   : 6.371,
      popups  : ['1', '2a', '4b'],
      talud   : 1,
      voorland: 1,
      ruwheidDijk : 0,
      ruwheidVoorland : 1,
    }
  },

  // 2
  {
    voorland: 0,
    ruwheid : 1,
    talud   : 1,
    debiet  : 0,
    stage   : {
      city    : 1,
      easter  : 0,
      house   : 1,
      factor  : 0.9881,
      kruin   : 7.550,
      popups  : ['2b', '4a'],
      talud   : 1,
      voorland: 0,
      ruwheidDijk : 1,
      ruwheidVoorland : 0,
    }
  },
  {
    voorland: 0,
    ruwheid : 1,
    talud   : 1,
    debiet  : 1,
    stage   : {
      city    : 1,
      easter  : 0,
      house   : 0,
      factor  : 0.9220,
      kruin   : 7.045,
      popups  : ['2b'],
      talud   : 1,
      voorland: 0,
      ruwheidDijk : 1,
      ruwheidVoorland : 0,
    }
  },
  {
    voorland: 0,
    ruwheid : 1,
    talud   : 1,
    debiet  : 2,
    stage   : {
      city    : 0,
      easter  : 0,
      house   : 0,
      factor  : 0.8948,
      kruin   : 6.837,
      popups  : ['2b', '4b'],
      talud   : 1,
      voorland: 0,
      ruwheidDijk : 1,
      ruwheidVoorland : 0,
    }
  },

  // 3
  {
    voorland: 1,
    ruwheid : 0,
    talud   : 1,
    debiet  : 0,
    stage   : {
      city    : 1,
      easter  : 0,
      house   : 1,
      factor  : 1.0026,
      kruin   : 7.661,
      popups  : ['1', '4a'],
      talud   : 1,
      voorland: 1,
      ruwheidDijk : 0,
      ruwheidVoorland : 0,
    }
  },
  {
    voorland: 1,
    ruwheid : 0,
    talud   : 1,
    debiet  : 1,
    stage   : {
      city    : 1,
      easter  : 0,
      house   : 0,
      factor  : 0.9237,
      kruin   : 7.058,
      popups  : ['1'],
      talud   : 1,
      voorland: 1,
      ruwheidDijk : 0,
      ruwheidVoorland : 0,
    }
  },
  {
    voorland: 1,
    ruwheid : 0,
    talud   : 1,
    debiet  : 2,
    stage   : {
      city    : 0,
      easter  : 0,
      house   : 0,
      factor  : 0.8915,
      kruin   : 6.812,
      popups  : ['1', '4b'],
      talud   : 1,
      voorland: 1,
      ruwheidDijk : 0,
      ruwheidVoorland : 0,
    }
  },

  // 4
  {
    voorland: 0,
    ruwheid : 0,
    talud   : 1,
    debiet  : 0,
    stage   : {
      city    : 1,
      easter  : 0,
      house   : 1,
      factor  : 1.0869,
      kruin   : 8.305,
      popups  : ['4a'],
      talud   : 1,
      voorland: 0,
      ruwheidDijk : 0,
      ruwheidVoorland : 0,
    }
  },
  {
    voorland: 0,
    ruwheid : 0,
    talud   : 1,
    debiet  : 1,
    stage   : {
      city    : 1,
      easter  : 0,
      house   : 0,
      factor  : 1.0000,
      kruin   : 7.641,
      popups  : [],
      talud   : 1,
      voorland: 0,
      ruwheidDijk : 0,
      ruwheidVoorland : 0,
    }
  },
  {
    voorland: 0,
    ruwheid : 0,
    talud   : 1,
    debiet  : 2,
    stage   : {
      city    : 0,
      easter  : 0,
      house   : 0,
      factor  : 0.9623,
      kruin   : 7.353,
      popups  : ['4b'],
      talud   : 1,
      voorland: 0,
      ruwheidDijk : 0,
      ruwheidVoorland : 0,
    }
  },

  // Talud vlak
  // 1
  {
    voorland: 1,
    ruwheid : 1,
    talud   : 0,
    debiet  : 0,
    stage   : {
      city    : 1,
      easter  : 0,
      house   : 1,
      factor  : 0.9022,
      kruin   : 6.894,
      popups  : ['1', '2a', '3b', '4a'],
      talud   : 0,
      voorland: 1,
      ruwheidDijk : 0,
      ruwheidVoorland : 1,
    }
  },
  {
    voorland: 1,
    ruwheid : 1,
    talud   : 0,
    debiet  : 1,
    stage   : {
      city    : 1,
      easter  : 0,
      house   : 0,
      factor  : 0.8499,
      kruin   : 6.494,
      popups  : ['1', '2a', '3b'],
      talud   : 0,
      voorland: 1,
      ruwheidDijk : 0,
      ruwheidVoorland : 1,
    }
  },
  {
    voorland: 1,
    ruwheid : 1,
    talud   : 0,
    debiet  : 2,
    stage   : {
      city    : 0,
      easter  : 0,
      house   : 0,
      factor  : 0.8292,
      kruin   : 6.336,
      popups  : ['1', '2a', '3b', '4b'],
      talud   : 0,
      voorland: 1,
      ruwheidDijk : 0,
      ruwheidVoorland : 1,
    }
  },

  // 2
  {
    voorland: 0,
    ruwheid : 1,
    talud   : 0,
    debiet  : 0,
    stage   : {
      city    : 1,
      easter  : 0,
      house   : 1,
      factor  : 0.9724,
      kruin   : 7.430,
      popups  : ['2b', '3b', '4a'],
      talud   : 0,
      voorland: 0,
      ruwheidDijk : 1,
      ruwheidVoorland : 0,
    }
  },
  {
    voorland: 0,
    ruwheid : 1,
    talud   : 0,
    debiet  : 1,
    stage   : {
      city    : 1,
      easter  : 0,
      house   : 0,
      factor  : 0.9173,
      kruin   : 7.009,
      popups  : ['2b', '3b'],
      talud   : 0,
      voorland: 0,
      ruwheidDijk : 1,
      ruwheidVoorland : 0,
    }
  },
  {
    voorland: 0,
    ruwheid : 1,
    talud   : 0,
    debiet  : 2,
    stage   : {
      city    : 0,
      easter  : 0,
      house   : 0,
      factor  : 0.8931,
      kruin   : 6.824,
      popups  : ['2b', '3b', '4b'],
      talud   : 0,
      voorland: 0,
      ruwheidDijk : 1,
      ruwheidVoorland : 0,
    }
  },

  // 3
  {
    voorland: 1,
    ruwheid : 0,
    talud   : 0,
    debiet  : 0,
    stage   : {
      city    : 1,
      easter  : 0,
      house   : 1,
      factor  : 0.9742,
      kruin   : 7.444,
      popups  : ['1', '3b', '4a'],
      talud   : 0,
      voorland: 1,
      ruwheidDijk : 0,
      ruwheidVoorland : 0,
    }
  },
  {
    voorland: 1,
    ruwheid : 0,
    talud   : 0,
    debiet  : 1,
    stage   : {
      city    : 1,
      easter  : 0,
      house   : 0,
      factor  : 0.9084,
      kruin   : 6.941,
      popups  : ['1', '3b'],
      talud   : 0,
      voorland: 1,
      ruwheidDijk : 0,
      ruwheidVoorland : 0,
    }
  },
  {
    voorland: 1,
    ruwheid : 0,
    talud   : 0,
    debiet  : 2,
    stage   : {
      city    : 0,
      easter  : 0,
      house   : 0,
      factor  : 0.8784,
      kruin   : 6.712,
      popups  : ['1', '3b', '4b'],
      talud   : 0,
      voorland: 1,
      ruwheidDijk : 0,
      ruwheidVoorland : 0,
    }
  },

  // 4
  {
    voorland: 0,
    ruwheid : 0,
    talud   : 0,
    debiet  : 0,
    stage   : {
      city    : 1,
      easter  : 0,
      house   : 1,
      factor  : 1.0521,
      kruin   : 8.039,
      popups  : ['3b', '4a'],
      talud   : 0,
      voorland: 0,
      ruwheidDijk : 0,
      ruwheidVoorland : 0,
    }
  },
  {
    voorland: 0,
    ruwheid : 0,
    talud   : 0,
    debiet  : 1,
    stage   : {
      city    : 1,
      easter  : 0,
      house   : 0,
      factor  : 0.9835,
      kruin   : 7.515,
      popups  : ['3b'],
      talud   : 0,
      voorland: 0,
      ruwheidDijk : 0,
      ruwheidVoorland : 0,
    }
  },
  {
    voorland: 0,
    ruwheid : 0,
    talud   : 0,
    debiet  : 2,
    stage   : {
      city    : 0,
      easter  : 0,
      house   : 0,
      factor  : 0.9486,
      kruin   : 7.248,
      popups  : ['3b', '4b'],
      talud   : 0,
      voorland: 0,
      ruwheidDijk : 0,
      ruwheidVoorland : 0,
    }
  },
]